import { Link } from 'react-router-dom';

export default function SideBar() {
    return (
        <div className="app-menu navbar-menu">
            {/* LOGO */}
            <div className="navbar-brand-box">
                {/* Dark Logo*/}
                <Link to={"/"} className="logo logo-dark">
                    <span className="logo-sm">
                        <img src="/assets/images/logo3d.jpg" alt height={22} />
                    </span>
                    <span className="logo-lg">
                        <img src="/assets/images/logo3d.jpg" alt height={17} />
                    </span>
                </Link>
                {/* Light Logo*/}
                <Link to={"/"} className="logo logo-light">
                    <span className="logo-sm">
                        <img src="/assets/images/logo3d.jpg" alt height={22} />
                    </span>
                    <span className="logo-lg">
                        <img src="/assets/images/logo3d.jpg" alt height={17} />
                    </span>
                </Link>
                <button type="button" className="btn btn-sm p-0 fs-20 header-item float-end btn-vertical-sm-hover" id="vertical-hover">
                    <i className="ri-record-circle-line" />
                </button>
            </div>
            <div id="scrollbar">
                <div className="container-fluid">
                    <div id="two-column-menu">
                    </div>
                    <ul className="navbar-nav" id="navbar-nav">
                        <li className="menu-title"><span data-key="t-menu">Menu</span></li>
                        {localStorage.getItem('roleName') === "ADMIN" ?
                            <>
                                <li className="nav-item">
                                    <Link className="nav-link menu-link" to={"/dashboard"}>
                                        <i className="mdi mdi-speedometer" /> <span data-key="t-dashboards">Dashboard</span>
                                    </Link>
                                </li>
                                <li className="nav-item">
                                    <Link className="nav-link menu-link" href="#clients" data-bs-toggle="collapse" role="button" aria-expanded="false" aria-controls="settings">
                                        <i className="mdi mdi-view-list" /> <span data-key="t-settings">Clients</span>
                                    </Link>
                                    <div className="collapse menu-dropdown" id="clients">
                                        <ul className="nav nav-sm flex-column">
                                            <li className="nav-item">
                                                <Link to={"/clients"} className="nav-link" data-key="t-analytics"> Clients </Link>
                                            </li>
                                            <li className="nav-item">
                                                <Link to={"/lendingApplications"} className="nav-link" data-key="t-crm"> Applications </Link>
                                            </li>
                                            <li className="nav-item">
                                                <Link to={"/leads"} className="nav-link" data-key="t-ecommerce"> Leads </Link>
                                            </li>
                                        </ul>
                                    </div>
                                </li>
                                <li className="nav-item">
                                    <Link className="nav-link menu-link" to={"/lenders"}>
                                        <i className="mdi mdi-format-list-bulleted" /> <span data-key="t-dashboards">Funders</span>
                                    </Link>
                                </li>
                                <li className="nav-item">
                                    <Link className="nav-link menu-link" to={"/industries"}>
                                        <i className="mdi mdi-plus-circle" /> <span data-key="t-dashboards">Industries</span>
                                    </Link>
                                </li>
                                <li className="nav-item">
                                    <Link className="nav-link menu-link" to={"/states"}>
                                        <i className="mdi mdi-map-marker" /> <span data-key="t-dashboards">States</span>
                                    </Link>
                                </li>
                                <li className="nav-item">
                                    <Link className="nav-link menu-link" href="#settings" data-bs-toggle="collapse" role="button" aria-expanded="false" aria-controls="settings">
                                        <i className="mdi mdi-cog" /> <span data-key="t-settings">Settings</span>
                                    </Link>
                                    <div className="collapse menu-dropdown" id="settings">
                                        <ul className="nav nav-sm flex-column">
                                            <li className="nav-item">
                                                <Link to={"/subscriptions"} className="nav-link" data-key="t-analytics"> Subscription Plans </Link>
                                            </li>
                                            <li className="nav-item">
                                                <Link to={"/creditpricing"} className="nav-link" data-key="t-crm"> Credit Pricing </Link>
                                            </li>
                                            <li className="nav-item">
                                                <Link to={"/creditusagepricing"} className="nav-link" data-key="t-ecommerce"> Credit Usage Pricing </Link>
                                            </li>
                                            <li className="nav-item">
                                                <Link to={"/pricing"} className="nav-link" data-key="t-ecommerce"> Pricing </Link>
                                            </li>
                                            <li className="nav-item">
                                                <Link to={"/landingpage"} className="nav-link" data-key="t-ecommerce"> Landing Page </Link>
                                            </li>
                                        </ul>
                                    </div>
                                </li>
                                <li className="nav-item">
                                    <Link className="nav-link menu-link" href="#reports" data-bs-toggle="collapse" role="button" aria-expanded="false" aria-controls="settings">
                                        <i className="mdi mdi-view-list" /> <span data-key="t-settings">Reports</span>
                                    </Link>
                                    <div className="collapse menu-dropdown" id="reports">
                                        <ul className="nav nav-sm flex-column">
                                            <li className="nav-item">
                                                <Link to={"/report/subscriptions"} className="nav-link" data-key="t-analytics"> Subscription Report </Link>
                                            </li>
                                            <li className="nav-item">
                                                <Link to={"/report/payments"} className="nav-link" data-key="t-crm"> Payment Report </Link>
                                            </li>
                                            <li className="nav-item">
                                                <Link to={"/report/clients"} className="nav-link" data-key="t-ecommerce"> Clients Report </Link>
                                            </li>
                                            <li className="nav-item">
                                                <Link to={"/applications/approved"} className="nav-link" data-key="t-ecommerce">Applications Approved</Link>
                                            </li>
                                            <li className="nav-item">
                                                <Link to={"/applications/rejected"} className="nav-link" data-key="t-ecommerce">Applications Rejected</Link>
                                            </li>
                                            <li className="nav-item">
                                                <Link to={"/lenders/rankings"} className="nav-link" data-key="t-ecommerce">Funders Commission</Link>
                                            </li>
                                            <li className="nav-item">
                                                <Link to={"/statusReport"} className="nav-link" data-key="t-ecommerce">Applications Status Report</Link>
                                            </li>
                                        </ul>
                                    </div>
                                </li>
                                <li className="nav-item">
                                    <Link className="nav-link menu-link" to={"/profile"}>
                                    <i className="mdi mdi-account" /> <span data-key="t-dashboards">Profile</span>
                                    </Link>
                                </li>
                            </> :
                            localStorage.getItem('roleName') === "CLIENT" ?
                                <>
                                    <li className="nav-item">
                                        <Link className="nav-link menu-link" to={"/userdashboard"}>
                                            <i className="mdi mdi-speedometer" /> <span data-key="t-dashboards">Dashboard</span>
                                        </Link>
                                    </li>
                                    <li className="nav-item">
                                        <Link className="nav-link menu-link" to={"/userdashboard/upload"}>
                                            <i className="mdi mdi-form-select" /> <span data-key="t-dashboards">New Application</span>
                                        </Link>
                                    </li>
                                    <li className="nav-item">
                                        <Link className="nav-link menu-link" to={"/userdashboard/applications"}>
                                            <i className="mdi mdi-account-search" /> <span data-key="t-dashboards">Leads</span>
                                        </Link>
                                    </li>
                                    <li className="nav-item">
                                        <Link className="nav-link menu-link" to={"/userdashboard/mylenders"}>
                                            <i className="mdi mdi-account-group" /> <span data-key="t-dashboards">Funders</span>
                                        </Link>
                                    </li>
                                    <li className="nav-item">
                                        <Link className="nav-link menu-link" to={"/userdashboard/brokers"}>
                                            <i className="mdi mdi-account-group-outline" /> <span data-key="t-dashboards">Brokers</span>
                                        </Link>
                                    </li>
                                    <li className="nav-item">
                                        <Link className="nav-link menu-link" href="#settings" data-bs-toggle="collapse" role="button" aria-expanded="false" aria-controls="settings">
                                            <i className="mdi mdi-cog" /> <span data-key="t-settings">Settings</span>
                                        </Link>
                                        <div className="collapse menu-dropdown" id="settings">
                                            <ul className="nav nav-sm flex-column">
                                                <li className="nav-item">
                                                    <Link to={"/userdashboard/profile"} className="nav-link" data-key="t-crm"> My Profile </Link>
                                                </li>
                                                <li className="nav-item">
                                                    <Link to={"/userdashboard/subscriptions"} className="nav-link" data-key="t-ecommerce"> My Plans </Link>
                                                </li>
                                                <li className="nav-item">
                                                    <Link to={"/userdashboard/templates"} className="nav-link" data-key="t-ecommerce"> My Templates </Link>
                                                </li>
                                                {/* <li className="nav-item">
                                                    <Link to={"/userdashboard/plans"} className="nav-link" data-key="t-analytics"> Subscription Plans </Link>
                                                </li> */}
                                                <li className="nav-item">
                                                    <Link to={"/userdashboard/usercredits"} className="nav-link" data-key="t-crm"> Credits History </Link>
                                                </li>
                                            </ul>
                                        </div>
                                    </li>
                                </>
                                :
                            localStorage.getItem('roleName') === "BROKER" ?
                                <>
                                    <li className="nav-item">
                                        <Link className="nav-link menu-link" to={"/broker/dashboard"}>
                                            <i className="mdi mdi-speedometer" /> <span data-key="t-dashboards">Dashboard</span>
                                        </Link>
                                    </li>
                                    <li className="nav-item">
                                        <Link className="nav-link menu-link" to={"/userdashboard/upload"}>
                                            <i className="mdi mdi-form-select" /> <span data-key="t-dashboards">New Application</span>
                                        </Link>
                                    </li>
                                    <li className="nav-item">
                                        <Link className="nav-link menu-link" to={"/broker/applications"}>
                                            <i className="mdi mdi-account" /> <span data-key="t-dashboards">Leads</span>
                                        </Link>
                                    </li>
                                    <li className="nav-item">
                                        <Link className="nav-link menu-link" href="#settings" data-bs-toggle="collapse" role="button" aria-expanded="false" aria-controls="settings">
                                            <i className="mdi mdi-cog" /> <span data-key="t-settings">Settings</span>
                                        </Link>
                                        <div className="collapse menu-dropdown" id="settings">
                                            <ul className="nav nav-sm flex-column">
                                                <li className="nav-item">
                                                    <Link to={"/userdashboard/profile"} className="nav-link" data-key="t-crm"> My Profile </Link>
                                                </li>
                                                <li className="nav-item">
                                                    <Link to={"/userdashboard/usercredits"} className="nav-link" data-key="t-crm"> Credits History </Link>
                                                </li>
                                            </ul>
                                        </div>
                                    </li>
                                </>
                                : ""}
                    </ul>
                </div>
                {/* Sidebar */}
            </div>
        </div>
    );
}
